import React from 'react'; // Add useContext here

function Navbar() {

  return (
    <nav className={`navbar navbar-light navbar-expand-sm`}>
      <div className="nav-bar-logo">
        Source
        <span className="distinct">lift</span>
        {/*
        <a href="/">
          Datapipe
          
          <img src={placelift_logo} alt="Placelift Logo" /> 
          
        </a>
        */}
      </div>

      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">

        <ul className="nav-links ms-auto navbar-nav mb-2 mb-lg-0">
          <li><a className="top-level-nav-item nav-item btn" href="#how-it-works">How it works</a></li>

          
            <>
              <li><a className="top-level-nav-item btn" href="#pricing">Pricing</a></li>
              <li><a className="btn btn-secondary" href="https://8ptby2lmwa9.typeform.com/to/UHCt2G8B">Get Started today</a></li>
            </>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
